module.exports = __webpack_public_path__ + "img/8.351f3ea6.webp";